import React from "react";
import { ShieldCheck } from "lucide-react";
import ServicePage from "./ServicePage";
import img4 from "../../assets/images/jpg/img4.jpg";

const service = {
  title: "Fencing",
  icon: ShieldCheck,
  image: img4,
  description:
    "Strong, tidy fencing solutions for privacy, boundary definition, safety, and improved outdoor presentation.",
  longText:
    "We provide fencing support for homes and commercial properties, helping you define boundaries, improve privacy, and add structure to your outdoor space. Our team focuses on clean installation, practical planning, and durable finishes.",
  points: [
    "Boundary fencing",
    "Privacy fence solutions",
    "Garden and landscape fencing",
    "Repair and replacement support",
    "Neat installation finish",
    "Residential and commercial work",
  ],
};

export default function Fencing() {
  return <ServicePage service={service} />;
}
